/**
 * Workbench Page
 * Main application interface
 */

import { WorkbenchCanvas } from '../../components/layout/WorkbenchCanvas';

export function WorkbenchPage() {
  return <WorkbenchCanvas />;
}
